import { pageKey } from '@/config';
import Sess from './sess';

function getPage() {
  return Sess.get(pageKey);
}

function setPage(page) {
  return Sess.set(pageKey, page);
}

function removePage() {
  return Sess.remove(pageKey);
}

export {
  getPage,
  setPage,
  removePage
};